<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-questionnaire`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.38 3a4 4 0 012.832 1.175l7.62 7.64A4 4 0 0142 14.64V43a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2h22.38zm-1.19 4H10v34h28V15.83a2 2 0 00-.584-1.412l-6.81-6.83A2 2 0 0029.19 7zM25 28a1 1 0 011 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1v-2a1 1 0 011-1h9zm7-10a1 1 0 011 1v2a1 1 0 01-1 1H16a1 1 0 01-1-1v-2a1 1 0 011-1h16z"/></svg>
</template>
<script>

export default {
  name: 'IconQuestionnaire',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
